import { CustomAxios } from './axios';

export const ContainerService = {
  buscarPorNumero: ({ numero }) => CustomAxios.get(`containers/buscar-por-numero/${numero}`),
  buscarPorId: ({ id }) => CustomAxios.get(`containers/buscar-por-id/${id}`),
};
